import React, { Suspense, useRef } from 'react';
import PropTypes from 'prop-types';
import { Comment, CommentForm, FloatingContainer, FloatingCommentButton } from '@contently/toolkit';
import { useResource } from 'rest-hooks';
import useTextEditorAnnotations from '../../hooks/useTextEditorAnnotations';
import AnnotationResource from '../../resources/AnnotationResource';
import useOutsideClick from '../../hooks/useOutsideClick';

function TextEditorAnnotationComment({ activeAnnotation, yPos, hide }) {
  const { comment } = useResource(AnnotationResource.detailShape(), { markId: activeAnnotation });
  const activeAnnotationRef = useRef(null);
  useOutsideClick(activeAnnotationRef, hide);
  if (!comment.id) return null;

  return (
    <div ref={activeAnnotationRef}>
      <FloatingContainer right="-420" top={yPos}>
        <Comment
          id={comment.id}
          body={comment.body}
          avatar={comment.authorable.avatar}
          fullName={comment.authorable.fullName}
          formattedCreatedAt={comment.formattedCreatedAt}
          authorIsEmployee={comment.authorIsEmployee}
          authorIsManagingEditor={comment.authorIsManagingEditor}
          onResolve={() => {}}
        />
      </FloatingContainer>
    </div>
  );
}

TextEditorAnnotationComment.defaultProps = {
  hide: true
};

TextEditorAnnotationComment.propTypes = {
  activeAnnotation: PropTypes.string.isRequired,
  yPos: PropTypes.number.isRequired,
  hide: PropTypes.bool
};

export default function TextEditorAnnotations({
  consumerApi,
  contentId,
  allContentIds,
  positionContainerRef
}) {
  const {
    showCommentButton,
    showCommentForm,
    activeAnnotation,
    setActiveAnnotation,
    yPos,
    handleNewAnnotation,
    handleSubmitComment,
    handleCancelComment
  } = useTextEditorAnnotations(consumerApi, contentId, allContentIds, positionContainerRef);

  return (
    <React.Fragment>
      {showCommentButton && (
        <FloatingCommentButton right="-72" top={yPos} onClick={handleNewAnnotation} />
      )}
      {showCommentForm && (
        <FloatingContainer right="-372" top={yPos}>
          <CommentForm onSubmit={handleSubmitComment} onCancel={handleCancelComment} />
        </FloatingContainer>
      )}
      {activeAnnotation && (
        <Suspense fallback={null}>
          <TextEditorAnnotationComment
            activeAnnotation={activeAnnotation}
            yPos={yPos}
            hide={() => setActiveAnnotation(null)}
          />
        </Suspense>
      )}
    </React.Fragment>
  );
}

TextEditorAnnotations.propTypes = {
  contentId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  consumerApi: PropTypes.any.isRequired,
  allContentIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  positionContainerRef: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/TextEditorAnnotations.jsx